export default __webpack_public_path__ + "static/media/Dragon Tribe.51667497.jpg";